module.exports = __webpack_public_path__ + "img/visa.046497e3.svg";